import { useDictionary } from "@adamlip/okeoke.client";
import { Button } from "@nextui-org/react";
import ProfileFields from "components/ProfileFields";
import { UserContext } from "contexts/UserContext";
import { useContext } from "react";
import { toast } from "react-hot-toast";
import { AppParamsContext } from "contexts/AppParamsContext";

function Profile() {
  const { getValue } = useDictionary();
  const { appParams } = useContext(AppParamsContext);
  const { saveUserData, logout } = useContext(UserContext);

  const handleResponse = (res) => {
    if (res.uuid || res.success) {
      toast.success(getValue("app_v2_toast_profileSuccess"));
    } else {
      toast.error(getValue("app_v2_toast_profileError"));
    }
  };

  const handleUserDataSave = () => {
    saveUserData(handleResponse);
  };

  const accountDelete = () => {
    toast.success(getValue("app_v2_toast_profileDeleteSuccess"));
  };

  return (
    <>
      <div className="text-xl font-bold">
        {getValue("app_v2_profile_title")}
      </div>
      <ProfileFields />
      <Button
        fullWidth
        color="primary"
        className={`${
          appParams?.styles?.fonts?.capitalize ? "font-extrabold uppercase" : ""
        } rounded-[var(--general-button-border-radius)]`}
        onClick={handleUserDataSave}
      >
        {getValue("app_v2_profile_save")}
      </Button>
      <Button
        color="danger"
        variant="flat"
        className={`${
          appParams?.styles?.fonts?.capitalize ? "font-extrabold uppercase" : ""
        } rounded-[var(--general-button-border-radius)] border-[var(--button2-border-color)] `}
        style={{ borderWidth: "var(--button2-border-width)" }}
        onClick={logout}
      >
        {getValue("app_v2_profile_logout")}
      </Button>
      <Button
        color="primary"
        variant="bordered"
        className={`${
          appParams?.styles?.fonts?.capitalize ? "font-extrabold uppercase" : ""
        } mt-4 rounded-[var(--general-button-border-radius)] border-[var(--button2-border-color)] `}
        style={{ borderWidth: "var(--button2-border-width)" }}
        onClick={accountDelete}
      >
        {getValue("app_v2_profile_deleteAccount")}
      </Button>
    </>
  );
}

export default Profile;
